const MASTER_ADMIN = 'MASTER';
const LIMITED_ADMIN = 'LIMITED';
const ADMIN_TYPES = {
    MASTER_ADMIN: 'MASTER',
    LIMITED_ADMIN: 'LIMITED'
};

export default { MASTER_ADMIN, LIMITED_ADMIN, ADMIN_TYPES };
